import { api } from '@/helpers/apiClient'
import { logRequestFailure } from '@/helpers/request-outcome'
import { venueSourcesDtoSchema, type VenueSourcesDto } from '@lib/dto/venue-sources.dto'
import type { PutVenueSourcesInput } from '@lib/input/venue-sources.input'
import type { ISourcesService } from '@/types/SourcesService.types'

/** Where a venue's couples come from (docs/ad-attribution.spec.md): its listing sites and what its lead source names mean. */
class SourcesServiceImpl implements ISourcesService {
  async venue(venueId: string): Promise<VenueSourcesDto> {
    try {
      return await api.get(`/venues/${venueId}/sources`, venueSourcesDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to load where the venue’s couples come from', { venueId }, error)
      throw error
    }
  }

  async saveVenue(venueId: string, input: PutVenueSourcesInput): Promise<VenueSourcesDto> {
    try {
      return await api.put(`/venues/${venueId}/sources`, input, venueSourcesDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to save where the venue’s couples come from', { venueId }, error)
      throw error
    }
  }
}

export const sourcesService: ISourcesService = new SourcesServiceImpl()
